/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EsercenteCassiereStatoAccountEsitoDTO { 
    stato?: EsercenteCassiereStatoAccountEsitoDTOStatoEnum;
    sessioni_revocate?: boolean;
}
export enum EsercenteCassiereStatoAccountEsitoDTOStatoEnum {
    BLOCCATO_DA_BACKOFFICE = 'BLOCCATO_DA_BACKOFFICE',
    EMAIL_NON_VERIFICATA = 'EMAIL_NON_VERIFICATA',
    IN_ATTESA_DI_ATTIVAZIONE = 'IN_ATTESA_DI_ATTIVAZIONE',
    ATTIVO = 'ATTIVO'
};



